import { useState } from "react";
import {
  Button,
  Checkbox,
  CurrencyInput,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "../../../../components";
import { Rnd } from "react-rnd";
import { Popover } from "@mui/material";
import { unformatPrice } from "../../../../utils";

const DesignEtiquetaTab = ({
  etiqueta,
  dimensoes,
  mmToPx,
  getEplFontSize,
  produto,
  setProduto,
  renderText,
  labelElements,
  setLabelElements,
  BarcodePreview,
  TYPECODE,
}) => {
  const [isTouchingBorder, setIsTouchingBorder] = useState(false);
  const [elementEdit, setElementEdit] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);

  const renderElementContent = (el) => {
    switch (el.elemento) {
      case "CODBAR":
        return (
          <>
            <TextField
              size="small"
              label="Código"
              value={elementEdit[el.elemento] || ""}
              onChange={(e) => {
                let elementEditTemp = {
                  ...elementEdit,
                  [el.elemento]: e.target.value,
                };
                const isNumeric = /^\d+$/.test(e.target.value);
                const getCodeType = (val) => {
                  if (!isNumeric) return "1";
                  if (val.length === 13) return "E30";
                  if (val.length === 8) return "E80";
                  return "1";
                };
                const newCodeType = getCodeType(e.target.value);
                if (newCodeType !== elementEdit.codeType) {
                  elementEditTemp.codeType = newCodeType;
                }
                setElementEdit(elementEditTemp);
              }}
              style={{
                width: "20em",
              }}
            />

            <Select
              size="small"
              value={el.codeType || "E30"}
              disableClearable
              onChange={(e) =>
                setElementEdit({ ...el, codeType: e.target.value })
              }
              style={{ width: "10rem" }}
            >
              <MenuItem value="1">Code128</MenuItem>
              <MenuItem value="3">Code39</MenuItem>
              <MenuItem value="E30">EAN13</MenuItem>
              <MenuItem value="E80">EAN8</MenuItem>
            </Select>

            <Checkbox
              checked={el.showLabelCode || false}
              onClick={(e) =>
                setElementEdit({ ...el, showLabelCode: e.target.checked })
              }
              color="primary"
            />
            <TextField
              size="small"
              type="number"
              label="Altura"
              value={el.codeHeight || 100}
              style={{ width: "10rem" }}
              onChange={(e) => {
                setElementEdit({
                  ...elementEdit,
                  codeHeight: e.target.value,
                });
              }}
              InputProps={{
                inputProps: { min: 20, step: 5 },
                endAdornment: (
                  <InputAdornment position="end">px</InputAdornment>
                ),
              }}
            />
            <TextField
              size="small"
              type="number"
              label="Largura"
              value={el.codeWidth || 4}
              style={{ width: "10rem" }}
              onChange={(e) => {
                setElementEdit({
                  ...elementEdit,
                  codeWidth: e.target.value,
                });
              }}
              InputProps={{
                inputProps: { min: 2, step: 1 },
                endAdornment: (
                  <InputAdornment position="end">px</InputAdornment>
                ),
              }}
            />
          </>
        );
      case "PRECO":
        return (
          <CurrencyInput
            size="small"
            label="Digite algo"
            margin="none"
            value={elementEdit[el.elemento] || ""}
            onBlur={(e) => {
              setElementEdit({
                ...elementEdit,
                [el.elemento]: unformatPrice(e.target.value),
              });
            }}
          />
        );
      default:
        return (
          <TextField
            size="small"
            label="Digite algo"
            value={elementEdit[el.elemento] || ""}
            onChange={(e) =>
              setElementEdit({
                ...elementEdit,
                [el.elemento]: e.target.value,
              })
            }
          />
        );
    }
  };

  const content = renderElementContent(elementEdit);

  function handleChangeElement() {
    setLabelElements((prev) =>
      prev.map((l) =>
        l.elemento === elementEdit.elemento ? { ...l, ...elementEdit } : l
      )
    );
    setProduto((prev) => ({
      ...prev,
      [elementEdit.elemento]: elementEdit[elementEdit.elemento],
    }));
    setAnchorEl(null);
  }

  function openChangeMenu(e, label) {
    e.preventDefault();
    setElementEdit({ ...label, ...produto });
    setAnchorEl(e.currentTarget);
  }

  return (
    <Grid
      item
      xs={12}
      direction="column"
      className="w-100 d-flex align-items-center mt-5"
    >
      <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
        Faça a formatação da sua etiqueta
      </Typography>
      <div
        className="rounded-4"
        style={{
          width: `${
            dimensoes.larguraEtiquetaPx / etiqueta?.colunasEtiqueta || 1
          }px`,
          minHeight: `${dimensoes.alturaEtiquetaPx}px`,
          border: "2px solid #ccc",
          padding: `0 ${dimensoes.margemLateralPx}px`,
          backgroundColor: "#f9f9f9",
          boxSizing: "border-box",
          position: "relative",
          fontFamily: "Inconsolata, monospace",
          fontWeight: 700,
        }}
      >
        <div
          className="rounded-3"
          style={{
            backgroundColor: "#FFFFFF",
            width: "100%",
            height: `${dimensoes.alturaEtiquetaPx}px`,
            overflow: "hidden",
            position: "relative",
            border: "1px solid #eee",
            padding: `${mmToPx(2.5)}px`,
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              border: isTouchingBorder ? "2px solid #FFC2B8" : "#ffffff",
              transition: "border-color 0.5s ease-in-out",
            }}
          >
            {labelElements.map((label) => (
              <Rnd
                style={{
                  overflow: "hidden",
                  textAlign: label.align || "left",
                  textOverflow: "ellipsis",
                  fontSize: `${getEplFontSize(label.fontSize)}px`,
                  whiteSpace: "nowrap",
                  userSelect: "none",
                }}
                key={label.elemento}
                bounds="parent"
                enableResizing={false}
                position={{
                  x: label.x,
                  y: label.y,
                }}
                onDrag={(_, d) => {
                  const { x, y } = d;
                  const parent = d.node.parentElement;
                  const parentWidth = parent.offsetWidth;
                  const parentHeight = parent.offsetHeight;
                  const elWidth = d.node.offsetWidth;
                  const elHeight = d.node.offsetHeight;

                  const touching =
                    x <= 0 ||
                    y <= 0 ||
                    x + elWidth >= parentWidth ||
                    y + elHeight >= parentHeight;

                  setIsTouchingBorder(touching);
                }}
                onDragStop={(_, direction) => {
                  const { x, y } = direction;
                  const newLabelElement = [...labelElements].map((l) => {
                    if (l.elemento === label.elemento) {
                      return {
                        ...l,
                        x,
                        y,
                      };
                    }
                    return l;
                  });
                  setLabelElements(newLabelElement);
                  setIsTouchingBorder(false);
                }}
              >
                {label.codeType ? (
                  <BarcodePreview
                    value={produto[label.elemento] || ""}
                    key={label.elemento}
                    type={TYPECODE[label.codeType]}
                    height={label.codeHeight || 80}
                    width={label.codeWidth || 8}
                    fontSize={getEplFontSize(label.fontSize)}
                    showValue={label.showLabelCode}
                    onContextMenu={(e) => openChangeMenu(e, label)}
                  />
                ) : (
                  <span
                    onContextMenu={(e) => openChangeMenu(e, label)}
                    style={{
                      overflowWrap: "anywhere",
                      height: label.height,
                    }}
                  >
                    {renderText(
                      label.fontSize,
                      produto[label.elemento],
                      label.elemento
                    )}
                  </span>
                )}
              </Rnd>
            ))}
            <Popover
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              transformOrigin={{ vertical: "top", horizontal: "center" }}
              slotProps={{
                paper: {
                  sx: {
                    borderRadius: 4,
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    gap: 2,
                    p: 2,
                  },
                },
              }}
            >
              <p className="m-0 flex-grow-1 fw-semibold">
                {elementEdit.content}
              </p>
              {content}
              <Select
                size={"small"}
                name="fontSize"
                value={elementEdit.fontSize || 5}
                label="Tamanho"
                disableClearable
                style={{
                  width: "9rem",
                }}
                onChange={(e) => {
                  setElementEdit({
                    ...elementEdit,
                    fontSize: e.target.value,
                  });
                }}
              >
                {Array.from({ length: 5 }).map((_, i) => (
                  <MenuItem key={i} value={i + 1}>
                    {i + 1}
                  </MenuItem>
                ))}
              </Select>
              <div className="d-flex gap-2">
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    height: "35px",
                    borderRadius: "20%",
                    minWidth: "18px",
                    boxShadow: "none",
                  }}
                  onClick={() => handleChangeElement()}
                >
                  <i
                    className="ph-fill ph-floppy-disk"
                    style={{ color: "#fff", fontSize: 20 }}
                  ></i>
                </Button>
              </div>
            </Popover>
          </div>
        </div>
      </div>
    </Grid>
  );
};

export default DesignEtiquetaTab;
